module.exports = __webpack_public_path__ + "static/img/colegio o persona.dd0d0cf4.png";